import Vue from 'vue'
import VueRouter from 'vue-router'
import { SnackType } from '@/interfaces/snack'
import { showNotification } from '@/utils/snack'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/goods'
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: () => import('@/views/SignIn.vue')
  },
  {
    path: '/goods',
    name: 'GoodsList',
    component: () => import('@/views/GoodsList.vue')
  },
  {
    path: '/goods/:id',
    name: 'GoodsDetail',
    component: () => import('@/views/GoodsDetail.vue')
  },
  {
    path: '/editgoods/:id?',
    name: 'EditGoods',
    component: () => import('@/views/EditGoods.vue'),
    meta: {
      requiresAuth: true,
      rights: ['ROOT', 'ADMIN']
    }
  },
  {
    path: '/orders',
    name: 'OrderList',
    component: () => import('@/views/OrderList.vue')
  },
  {
    path: '/order/:id',
    name: 'OrderDetail',
    component: () => import('@/views/OrderDetail.vue')
  },
  {
    path: '/editorder/:id?',
    name: 'EditOrder',
    component: () => import('@/views/EditOrder.vue')
  },
  {
    path: '/refundOrder',
    name: 'RefundOrder',
    component: () => import('@/views/OrderRefund.vue')
  },
  {
    path: '/audit',
    name: 'RefundAudit',
    component: () => import('@/views/RefundAudit.vue')
  },
  {
    path: '/refunds',
    name: 'RefundList',
    component: () => import('@/views/RefundList.vue')
  },
  {
    path: '/schools',
    name: 'SchoolList',
    component: () => import('@/views/SchoolList.vue')
  },
  {
    path: '/school/:id',
    name: 'SchoolDetail',
    component: () => import('@/views/SchoolDetail.vue')
  },
  {
    path: '/editschool/:id?',
    name: 'EditSchool',
    component: () => import('@/views/EditSchool.vue'),
    meta: {
      requiresAuth: true,
      rights: ['ROOT', 'ADMIN']
    }
  },
  {
    path: '/dealers',
    name: 'DealerList',
    component: () => import('@/views/DealerList.vue')
  },
  {
    path: '/editdealer/:id?',
    name: 'EditDealer',
    component: () => import('@/views/EditDealer.vue'),
    meta: {
      requiresAuth: true,
      rights: ['ROOT', 'ADMIN']
    }
  },
  {
    path: '/dealer/:id/detail',
    name: 'DealerDetail',
    component: () => import('@/views/DealerDetail.vue')
  },
  {
    path: '/dealer/:id/goods',
    name: 'EditDealerGoods',
    component: () => import('@/views/DealerDetail/pages/EditDealerGoods.vue'),
    meta: {
      requiresAuth: true,
      rights: ['ROOT', 'ADMIN']
    }
  },
  {
    path: '/dealer/:id/school',
    name: 'EditDealerSchool',
    component: () => import('@/views/DealerDetail/pages/EditDealerSchool.vue'),
    meta: {
      requiresAuth: true,
      rights: ['ROOT', 'ADMIN']
    }
  },
  {
    path: '/members',
    name: 'MemberList',
    component: () => import('@/views/MemberList.vue'),
    meta: {
      requiresAuth: true,
      rights: ['ROOT', 'ADMIN']
    }
  },
  {
    path: '/member/:id',
    name: 'MemberDetail',
    component: () => import('@/views/MemberDetail.vue'),
    meta: {
      requiresAuth: true,
      rights: ['ROOT', 'ADMIN']
    }
  },
  {
    path: '/changePassword',
    name: 'ChangePassword',
    component: () => import('@/views/ChangePassword.vue')
  },
  {
    path: '/managers',
    name: 'ManagerList',
    component: () => import('@/views/ManagerList.vue'),
    meta: {
      requiresAuth: true,
      rights: ['ROOT', 'ADMIN']
    }
  },
  {
    path: '/subscriptionCycle',
    name: 'SubscriptionCycle',
    component: () => import('@/views/SubscriptionCycle.vue'),
    meta: {
      requiresAuth: true,
      rights: ['ROOT', 'ADMIN']
    }
  },
  {
    path: '/profitSharings',
    name: 'ProfitSharingsList',
    component: () => import('@/views/ProfitSharingsList.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'SignIn' && !localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_KEY as string)) {
    next({ name: 'SignIn' })
  } else {
    const role = sessionStorage.getItem('role')
    if (to.meta.requiresAuth) {
      if (role !== 'DEALER') {
        next()
      } else {
        showNotification({
          msg: '无权限访问',
          type: SnackType.Error
        })
        next({ path: from.path })
      }
    } else {
      next()
    }
  }
})

export default router
